
import { PuttSituation } from "@/types/golf";

export const longChips: PuttSituation = {
  id: 8,
  name: "Chips longs",
  image: "/lovable-uploads/9800ffe6-7c6f-47ac-9ba9-690510830e26.png",
  description: "Sur le green d'approche ou sur le parcours choisissez un trou et matérialisez la position de départ de cette situation de jeu. Placer une marque au point B=20m disposée entre le bord du green et un trou à 15 m minimum du bord de green. Jouez ensuite 10 balles successivement.",
  distances: [
    { point: "B", distance: 20, ballCount: 10 },
  ],
  scoring: [
    { condition: "Balle rentrée", points: 4 },
    { condition: "Balle à moins de 1m", points: 2 },
    { condition: "Balle entre 1m et 2m", points: 1 },
    { condition: "Balle au-delà de 2m", points: 0 },
  ],
  indexTable: [
    { points: 0, index: 38 },
    { points: 1, index: 35 },
    { points: 2, index: 32 },
    { points: 3, index: 29 },
    { points: 4, index: 26 },
    { points: 5, index: 24 },
    { points: 6, index: 22 },
    { points: 7, index: 20 },
    { points: 8, index: 18 },
    { points: 9, index: 16 },
    { points: 10, index: 14 },
    { points: 11, index: 12 },
    { points: 12, index: 10 },
    { points: 13, index: 8 },
    { points: 14, index: 6 },
    { points: 15, index: 4 },
    { points: 16, index: 2 },
    { points: 17, index: 0 },
    { points: 18, index: -2 },
    { points: 19, index: -5 },
    { points: 20, index: -8 },
  ],
};
